module.exports = __webpack_public_path__ + "img/C539.4ec5dab0.jpg";